import { gql } from '@apollo/client'

export const SimpleResultFragment = gql`
  fragment SimpleResult on SimpleResult {
    ok
    message
  }
`
